module.exports = __webpack_public_path__ + "img/box6_icon3.a0eb6eed.jpg";